// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14LF5","comment":"styles_comment__1MKCv"};